<template>
  <div class="flex flex-col bg-white">
    <div v-if="courselist_loading" class="flex h-screen items-center justify-center">
      <pl-spinner class="x3" />
    </div>
    <div v-else class="flex-grow">
      <DefaultLayout>
        <CourseTable/>
      </DefaultLayout>
    </div>
  </div>
</template>
<script>
  import store from 'store';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import DefaultLayout from 'layouts/default/default.vue';

  /* Services */
  /* import AccountService from 'services/account'; */


  export default {
    data() {
      return {
        courselist_loading: false,
      };
    },
    watch: {
      'getProfile.role'() {
        this.getCoursesList();
      },
    },
    components: {
      CourseTable: () => import('../../Pages/Courses/Courses.vue'),
      DefaultLayout,
    },
    computed: {
      ...mapGetters([
        'getCourseLoading',
        'getDashboardRole',
        'getProfile',
        'getCourses',
        'getInstructorCourses',
        'getParticipantCourses'
      ]),
    },
    methods: {
      getCoursesList: async function() {
        const role = this.getProfile.role;
        if (role !== 'admin') {
          this.courselist_loading = true;
          if (role === 'student' && this.getParticipantCourses.length === 0) {
            await store.dispatch('handleSetParticipantCourses', { role: 'student' });
          }
          if (role === 'teacher' && this.getInstructorCourses.length === 0 && this.getParticipantCourses.length === 0) {
            await Promise.all([
              store.dispatch('handleSetInstructorCourses', { role }),
              store.dispatch('handleSetParticipantCourses', { role: 'teacher' })              
            ]);
          }
        }
        this.courselist_loading = false;
      },
    },
    async mounted() {
      const role = this.getProfile.role;
      await this.getCoursesList();
      if (role === 'teacher' && this.getProfile.is_onboarded === false) {
        EventBus.$emit('open-welcome-modal');
      }
    },
    beforeDestroy: async function() {
      if (this.getDashboardRole === 'teacher') {
        await store.dispatch('handleSetInstructorCourses', { role: this.getDashboardRole, page: 1 });
      }
      if (this.getDashboardRole === 'student') {
        await store.dispatch('handleSetParticipantCourses', { role: 'student', page: 1 });
      }
      
    }
  };
</script>



// WEBPACK FOOTER //
// myCourses.vue?2e7c936e